import styled from "styled-components";
import { CheckIcon } from "./CheckIcon";

const Button = styled.button`
  display: flex;
  align-items: center;
  gap: 6px;

  padding: 6px 12px;
  border-radius: 999px;

  border: 1px solid
    ${(props) => {
      if (!props.$active) return "#d1d5db";

      if (props.$status === "checked") return "#C2C8CF";
      if (props.$status === "late") return "#CECCBE";

      return "#C2C8B9";
    }};

  background:
    ${(props) => {
      if (!props.$active) return "#ffffff";

      if (props.$status === "checked") return "#DEE0E5";
      if (props.$status === "late") return "#E4E4D9";

      return "#DCDFD4";
    }};

  color: ${(props) =>
    props.$active ? "#000000" : "#000000"};

  cursor: pointer;

  transition: all 0.2s;

  &:hover {
    opacity: 0.9;
  }
`;

export function StatusFilterButton({
  label,
  checked,
  status,
  onClick,
}) {
  return (
    <Button
      type="button"
      $status={status}
      $active={checked}
      onClick={onClick}
    >
      <CheckIcon checked={checked} />
      {label}
    </Button>
  );
}